import { render, staticRenderFns } from "./help_link.vue?vue&type=template&id=f0cb8ac6&"
import script from "./help_link.vue?vue&type=script&lang=js&"
export * from "./help_link.vue?vue&type=script&lang=js&"
import style0 from "./help_link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0cb8ac6')) {
      api.createRecord('f0cb8ac6', component.options)
    } else {
      api.reload('f0cb8ac6', component.options)
    }
    module.hot.accept("./help_link.vue?vue&type=template&id=f0cb8ac6&", function () {
      api.rerender('f0cb8ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/help_link.vue"
export default component.exports